import React, { useEffect, useRef, useState } from 'react'
import closeIcon from '../../assets/images/closeIcon.svg'
import personAddIcon from '../../assets/images/personAddIcon.svg'
import SelectField from '../inputFeild/SelectField';
import { ReceiverUser } from '../../models/triageQueueInterface';
import { MSG_CLIENT_ADMIN, MSG_CLIENT_ASSOCIATE, MSG_NURSING_STAFF, MSG_PROVIDER } from '../../config/permissions';


interface IMessageToInterface {
  value: ReceiverUser[];
  onChange?: (value: ReceiverUser[]) => void;
}

const MessageTo: React.FC<IMessageToInterface> = (props) => {

  //When clicking on the message area, focus needs to move on to the input field.
  const inputRef = useRef<HTMLInputElement | null>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  // To close the dropdown while clicking out side
  useEffect(() => {
    const closeSelects = (e: MouseEvent) => {
      if (!e.target || !(e.target instanceof Node)) return;
      if (!dropdownRef.current?.contains(e.target as Node)) {
        setUiModifier(prev => ({ ...prev, toMessageDropdown: false }));
      }
    };
    document.addEventListener('mousedown', closeSelects);
    return () => {
      document.removeEventListener('mousedown', closeSelects);
    };
  }, []);

  const getLabelByValue = (value: string): string => {
    switch (value) {
      case MSG_CLIENT_ADMIN:
        return "Client Admin";
      case MSG_CLIENT_ASSOCIATE:
        return "Associates";
      case MSG_NURSING_STAFF:
        return "Facility Staff";
      case MSG_PROVIDER:
        return "Providers";
      default:
        return value;
    }
  };

  const [uiModifier, setUiModifier] = useState({
    validation: false,
    search: "",
    toMessageDropdown: false,
    extraSpace: false,
    selMessageToType: "",
  });


//To extract the group names and their corresponding isSelected values to use in filteredOptions
  const selectedGroupMap = new Map(
    props.value
      .filter(item => item.group_name === "")
      .map(item => [item.value, item.isSelected])
  );
//To extract the group names and setting up isSelected using entire user list
  const filteredOptions = Array.from(
    new Map(
      props.value
        .filter(item => item.group_name !== "")
        .map(item => [
          item.group_name,
          {
            name: getLabelByValue(item.group_name),
            id: item.group_name,
            value: item.group_name,
            isSelected: selectedGroupMap.get(item.group_name) || false,
          }
        ])
    ).values()
  );


  //function to give focus to the input field.
  const handleClickOnToMessage = () => {
    setUiModifier(prev => ({ ...prev, toMessageDropdown: true }));
    if (inputRef.current) {
      inputRef.current.focus(); // Focus on the input element
    }
  };

  
  const handleToMessage = (obj: any, isGroup: boolean) => {

    setUiModifier(prev => ({ ...prev, search: "" }));

    let updatedList: ReceiverUser[] = [];

    if (isGroup) {
      const groupExists = props.value.some(item => item.value === obj.value);

      updatedList = groupExists
        ? props.value.map(item => {
          if (item.group_name === obj.value || item.value === obj.value) {
            return { ...item, isSelected: !obj.isSelected, isGroup: !item.isGroup };
          }
          return item;
        })
        : [
          ...props.value.map(item =>
            item.group_name === obj.value
              ? { ...item, isSelected: true, isGroup: true }
              : item
          ),
          {
            name: getLabelByValue(obj.value),
            value: obj.value,
            group_name: '',
            isSelected: true,
            isGroup: false
          }
        ];

      props.onChange?.(updatedList);
    } else if (!obj.isGroup) {
      updatedList = props.value.map(user =>
        user.user_id === obj.user_id
          ? { ...user, isSelected: !user.isSelected }
          : user
      );
      props.onChange?.(updatedList);
    }


    

    // Validation check
    if (updatedList.every(item => item.isSelected === false)) {
      setUiModifier(prev => ({ ...prev, validation: true }));
    }else{
      setUiModifier(prev => ({ ...prev, validation: false }));
    }
  };




  return (
    <div className="flex gap-4 w-full ">


      <div className={`common-dropdown w-full`} onClick={handleClickOnToMessage}>
        <div className='extra-space '></div>
        <div className={` ${(uiModifier.validation) ? " border-[var(--color-danger)] " : " border-[var(--color-EEE)] "} rounded p-2 common-input  flex flex-wrap gap-[9px]`}>

          {
            props.value.filter(item => item.isSelected && !item.isGroup).map(item => (
              <div key={item.value} className='bg-[var(--color-EEEEEE)] rounded flex items-center gap-[10px] w-fit px-2 py-1 z-[1]'>
                <p className='text-xs font-medium text-[var(--color-424242)] w-full cursor-default'>{item.name}</p> <img src={closeIcon} alt="" loading='lazy' decoding='async' className='cursor-pointer' onClick={() => handleToMessage(item, item.user_id ? false : true)} />
              </div>
            ))}


          <input type="text" name="" id="" className='border-none focus:outline-none' value={uiModifier.search} onChange={(e) => setUiModifier(prev => ({ ...prev, search: e.target.value }))} ref={inputRef} />

        </div>

        <div className={`${(uiModifier.search.length > 0 && uiModifier.toMessageDropdown) ? 'block py-6 pl-6 dropdown-list w-[288px]  top-full left-0 ' : 'hidden'}  `} ref={dropdownRef}>


          <span className='text-sm font-medium text-[var(--color-9E9E9E)] '>Groups</span>
          <ul className="custom-scrollBar max-h-[250px] flex flex-col gap-1 mt-2">
            {filteredOptions.filter(option =>
              option.name.toLowerCase().includes(uiModifier.search.toLowerCase())
            ).map(item => (
              <li
                key={item.id}
                className={`${item.isSelected ? " bg-[var(--color-0048d41a)] text-[var(--color-0048D4)] font-medium" : " bg-[var(--color-FAFAFA)] text-[var(--color-757575)]"} dropdown-btn w-fit`}
                onClick={() => handleToMessage(item, true)}
              >
                {item.name}
              </li>
            ))}
          </ul>
          {(props.value.filter(
            (option) =>
              option.name.toLowerCase().includes(uiModifier.search.toLowerCase())
          ).length > 0) && <hr className='border-[var(--color-EEE)] my-2 mr-6' />}


          <span className='text-sm font-medium text-[var(--color-9E9E9E)] '>Individual</span>
          <ul className="custom-scrollBar max-h-[250px] flex flex-col  gap-1 mt-2">
            {props.value.filter(
              (option) =>
                option.name.toLowerCase().includes(uiModifier.search.toLowerCase()) && option.user_id
            ).map(item => (
              <li
                key={item.value}
                className={`${item.isSelected || item.isGroup ? " bg-[var(--color-0048d41a)] text-[var(--color-0048D4)] font-medium" : " bg-[var(--color-FAFAFA)] text-[var(--color-757575)]"} dropdown-btn w-fit `}
                onClick={() => handleToMessage(item, false)}
              >
                {item.name}
              </li>
            ))}
          </ul>


        </div>
      </div>


      <div className={`common-dropdown rounded bg-[var(--color-253179)] px-3 max-h-11 w-11`}>
        <div className={`${uiModifier.extraSpace && "h-[460px] min-w-[288px] "} extra-space z-[1] right-0 w-[65px] `}></div>
        <div className='w-11 '>
          <img src={personAddIcon} alt="" loading='lazy' decoding='async' />
        </div>

        <div className={`py-6 pl-6 dropdown-list min-w-[288px]  top-[50px] right-0`}>
          <span className='text-sm font-medium text-[var(--color-9E9E9E)] '>Groups</span>
          <ul className="custom-scrollBar max-h-[250px] flex flex-col  gap-1 mt-2">
            {filteredOptions.map(item => (
              <li
                key={item.id}
                className={`${item.isSelected ? " bg-[var(--color-0048d41a)] text-[var(--color-0048D4)] font-medium" : " bg-[var(--color-FAFAFA)] text-[var(--color-757575)]"} dropdown-btn w-fit`}
                onClick={() => handleToMessage(item, true)}
              >
                {item.name}
              </li>
            ))}
          </ul>
          <hr className='border-[var(--color-EEE)] my-2 mr-6 -ml-[7px]' />
          {/* <span className='text-sm font-medium text-[var(--color-9E9E9E)] '>Individual</span> */}
          <div className='mr-6 -ml-[7px] '>
            <SelectField
              className={`pr-10 py-[6px] rounded border-[var(--color-EEE)] mr-6 text-sm font-medium text-[var(--color-9E9E9E)]`}
              onChange={(e) => {
                setUiModifier(prev => ({ ...prev, selMessageToType: e.target.value }));

                setTimeout(() => {
                  setUiModifier(prev => ({ ...prev, extraSpace: false }));
                }, 5000);
              }}
              onClick={() => setUiModifier(prev => ({ ...prev, extraSpace: !uiModifier.extraSpace }))}
              value={uiModifier.selMessageToType}
              options={[{ name: 'Select Group', id: '' }, ...filteredOptions]}
            />
          </div>
          {uiModifier.selMessageToType && uiModifier.selMessageToType.trim().length > 0 && <ul className="custom-scrollBar max-h-[250px] flex flex-col  gap-1 mt-2">
            {props.value.filter(item => item.group_name === uiModifier.selMessageToType).map(option => (
              <li
                key={option.value}
                className={`${option.isSelected || option.isGroup ? " bg-[var(--color-0048d41a)] text-[var(--color-0048D4)] font-medium" : " bg-[var(--color-FAFAFA)] text-[var(--color-757575)]"} dropdown-btn w-fit `}
                onClick={() => handleToMessage(option, false)}
              >
                {option.name}
              </li>
            ))}
          </ul>}
        </div>
      </div>

    </div>
  )
}

export default MessageTo